import * as Yup from 'yup';

export default Yup.object().shape({
  supplier: Yup.object().shape({
    categories_tier1: Yup.string().required(
      'Select what type of service you offer.'
    ),
  }),
});
